import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from '../services/ApiService';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import DatePicker from 'react-datepicker'
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useParams } from 'react-router-dom';
import {
    Box, Container, Typography, useTheme,
} from '@mui/material';

interface PendingPost {
    postId: number,
    channelId: number,
    channelName: string,
    channelType: string,
    content: string,
    mediaFilesCount: number,
    status: number,
    errorMessage: string
}


const PendingPosts = () => {

    const [rows, setRows] = React.useState<PendingPost[]>();
    const [randomState, setRandomState] = React.useState<number>(0);//Just for triggering interval with correct store data
    const { postId } = useParams<{ postId: string }>();
    const postIdNumber = Number(postId);
    const [selectedPostId, setSelectedPostId] = React.useState<number>(postIdNumber);

    const theme = useTheme();

    const getPostsData = () => {
        axios.get("content/GetPendingPosts").then((data) =>
            setRows(data.data));
    }

    const scrollToPost = (postId: number) => {
        window.setTimeout(() => {
            const element = document.getElementById(`post-${postId}`);
            const offset = 5;
            if (element) {
                window.scrollTo({
                    top: element.offsetTop - offset,
                    behavior: "smooth"
                });
            }
        }, 100);

    }


    React.useEffect(() => {
        getPostsData();
        setSelectedPostId(postIdNumber);
        scrollToPost(postIdNumber);
    }, [postIdNumber])

    const approvePost = (postId: number) => {
        axios.post('content/ApprovePost', { postId: postId }).then((response) => {
            console.log(response);
        });
    }

    React.useEffect(() => {
        getPostsData();
    }, [randomState])

    React.useEffect(() => {
        const interval = setInterval(() => {
            setRandomState((ps) => ps + 1);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Container maxWidth="xl" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 2 }}>
                Pending posts
            </Typography>
            <Typography variant="body2" sx={{ mb: 4 }}>
                Approve pending posts for your social media accounts
            </Typography>
            <Card
                variant="outlined"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    {rows && rows.length > 0 ? (
                        <TableContainer component={Paper} sx={{ flexGrow: 1 }}>
                            <Table sx={{ minWidth: 650 }} size="small" aria-label="pending posts table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Content</TableCell>
                                        <TableCell>Channel Name</TableCell>
                                        <TableCell>Channel Type</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell align="center">Media Files Count</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow
                                            key={row.postId}
                                            id={`post-${row.postId}`}
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                                backgroundColor:
                                                    row.postId === selectedPostId
                                                        ? theme.palette.mode === 'dark'
                                                            ? '#2e7d32'
                                                            : '#c8e6c9'
                                                        : 'inherit',
                                            }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {row.content}
                                            </TableCell>
                                            <TableCell>{row.channelName}</TableCell>
                                            <TableCell>{row.channelType}</TableCell>
                                            <TableCell>
                                                {row.status === 5 && <Chip label="Rescheduled" color="info" />}
                                                {row.status === 3 && <Chip label="Delivered" color="info" />}
                                                {row.status === 6 && <Chip label="Published" color="success" />}
                                                {row.status === 2 && <Chip label="Approved" color="primary" />}
                                                {(row.status === 1 || row.status === 0) && (
                                                    <Chip label="Pending" color="secondary" />
                                                )}
                                                {row.status === 4 && (
                                                    <Tooltip title={row.errorMessage} placement="top">
                                                        <Chip label="Error" color="error" />
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.mediaFilesCount === 0 ? 'N/A' : row.mediaFilesCount}
                                            </TableCell>
                                            <TableCell>
                                                {row.status === 5 && <RescheduleButton postId={row.postId} />}
                                                {(row.status === 1 || row.status === 0) && (
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => approvePost(row.postId)}
                                                        sx={{
                                                            color: '#FFF !important',
                                                            textTransform: 'none !important',
                                                            borderRadius: 0,
                                                        }}
                                                    >
                                                        Approve Post
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'background.paper',
                            }}
                        >
                            <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                                No data found
                            </Typography>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Container>
    );
}

export default PendingPosts;


interface RescheduleButtonProps {
    postId: number;
}

const RescheduleButton: React.FC<RescheduleButtonProps> = ({ postId }) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
    const [showDateTimeComponent, setShowDateTimeComponent] = React.useState<boolean>(false);


    const handleDateTimeTooltipClose = () => {
        setShowDateTimeComponent(false);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const approvePost = (postId: number) => {
        axios.post('content/ApprovePost', { postId: postId, scheduledTime: selectedDate }).then((response) => {
            console.log(response);
        });
    }


    const open = Boolean(anchorEl);

    const ScheduleButton = React.forwardRef<any, any>(({ value, onClick }, ref) => {
        return <Button onClick={onClick} ref={ref} sx={{ borderRadius: 0, color: "#FFF !important", textTransform: "none !important" }}>
            Reschedule
        </Button>
    });

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
        },
    }));

    return (<ClickAwayListener onClickAway={handleClose}>
        <div>
            <ButtonGroup variant="contained" disableElevation aria-label="button group">
                <Button
                    onClick={() => approvePost(postId)}
                    sx={{ borderRadius: 0, color: "#FFF !important", textTransform: "none !important" }}
                >
                    Approve
                </Button>
                <DatePicker
                    selected={selectedDate}
                    onChange={(date: Date | null) => date instanceof Date && setSelectedDate(date)}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                    customInput={<ScheduleButton />}
                />
                <span></span>
                <HtmlTooltip
                    PopperProps={{
                        disablePortal: true,
                    }}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    onClose={handleDateTimeTooltipClose}
                    open={showDateTimeComponent}
                    title={
                        <>
                        </>
                    }
                    placement="left-start"
                >
                    <span></span>
                </HtmlTooltip>
            </ButtonGroup>
        </div>
    </ClickAwayListener>
    );
};
